import { createContext, useCallback, useContext, useMemo, useState } from "react";

import ConfirmationDialog from "../components/notifications/ConfirmationDialog";
import NotificationList from "shared/components/notifications/NotificationList";

const NotificationContext = createContext();

export const useNotification = () => useContext(NotificationContext);

let idCounter = 0;

export const NotificationProvider = ({ children }) => {
    const [notifications, setNotifications] = useState([]);
    const [confirmation, setConfirmation] = useState(null);

    const notify = useCallback((type, message, duration = 3000) => {
        const id = ++idCounter;
        const newNotification = { id, type, message };

        setNotifications((prev) => [...prev, newNotification]);

        // Auto-dismiss
        if (duration) {
            setTimeout(() => {
                setNotifications((prev) => prev.filter((n) => n.id !== id));
            }, duration);
        }
    }, []);

    const confirm = useCallback((message, { onConfirm, onCancel, icon, confirm, cancel }) => {
        setConfirmation({ message, onConfirm, onCancel, icon, confirm, cancel});
    }, []);

    const removeNotification = (id) => {
        setNotifications((prev) => prev.filter((n) => n.id !== id));
    };

    const notificationApi = useMemo(() => ({
        success: (msg, d) => notify("success", msg, d),
        error: (msg, d) => notify("error", msg, d),
        info: (msg, d) => notify("info", msg, d),
        warning: (msg, d) => notify("warning", msg, d),
        confirm,
    }), [confirm, notify]);

    return (
        <NotificationContext.Provider
            value={{
                notify: notificationApi,
            }}
        >
            {children}

            <NotificationList
                notifications={notifications}
                removeNotification={removeNotification}
            />

            {confirmation && (
                <ConfirmationDialog
                    data={confirmation}
                    onClose={() => setConfirmation(null)}
                />
            )}
        </NotificationContext.Provider>
    );
};
